import styled from "styled-components";

export const SwitchStyle = styled.div`
  label {
    color: ${({ theme }) => theme.primary.dark};
  }
`;
